import { CreditCardDetails } from 'scenes/common/types';
import { WestpacRequest } from './types';

const getMonth = (expiryDate: string) => expiryDate.substring(0, 2);
const getYear = (expiryDate: string) => expiryDate.substring(2);

export const marshalRequest = (
  supplierBusinessCode: string,
  creditCardDetails: CreditCardDetails
): WestpacRequest => {
  const { cardName, cardNumber, cardExpiry, cardCvv } = creditCardDetails;
  return {
    supplierBusinessCode,
    accountType: 'CREDIT_CARD',
    cardholderName: cardName,
    cardNumber,
    expiryDateMonth: getMonth(cardExpiry),
    expiryDateYear: getYear(cardExpiry),
    cvn: cardCvv,
  };
};
